import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const canActivateBook2Guard: CanActivateFn = () => {
  if (sessionStorage.getItem('book2Unlocked') === '1') return true;
  return inject(Router).createUrlTree(['/bienal']);
};